import { render, staticRenderFns } from "./SearchBarWidgets.vue?vue&type=template&id=4fe983f0&scoped=true"
import script from "./SearchBarWidgets.vue?vue&type=script&lang=js"
export * from "./SearchBarWidgets.vue?vue&type=script&lang=js"
import style0 from "./SearchBarWidgets.vue?vue&type=style&index=0&id=4fe983f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe983f0",
  null
  
)

export default component.exports